import MaterialTable from 'material-table';
import React, { Component } from 'react';
import { forwardRef } from 'react';

import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Search from '@material-ui/icons/Search';

const tableIcons = {
	FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
	LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
	NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
	ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
	SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
};

class TablaCurso extends Component {

	constructor (props) {
		super(props);
		this.state = {
			dataTablaCurso: this.props.data.dataTablaCurso
		};
	}

	componentDidUpdate = (prevProps) => {
		if(prevProps != this.props){
			this.setState({dataTablaCurso: this.props.data.dataTablaCurso})
		}
	}

	render(){
		return (
			<MaterialTable
				title=""
				icons={tableIcons}
				columns={[
					{ title: 'Matrícula', field: 'matricula', render: rowData => <a href={rowData.url_matricula} target="_blank">{rowData.matricula}</a> },
					{ title: 'Nombre', field: 'nombre' },
					{ title: 'Apellidos', field: 'apellidos' },
					{ title: 'Email', field: 'email' },
					{ title: 'Nivel', field: 'nivel'},
					{ title: 'Grupo', field: 'grupo'},
					{ title: 'Último acceso', field: 'ultimo_acceso'},
					{ title: 'Status', field: 'status'},
				]}
				data={this.state.dataTablaCurso}     
				options={{
					headerStyle: {
						borderBottom: '2px solid #FF6F00',
					},
					rowStyle: {
						backgroundColor: '#f7f7f7',
					},
					draggable: false,
					pageSize: 10,
					pageSizeOptions: [10, 20],
				}}
				localization={{
					body: {
						emptyDataSourceMessage: 'Sin resultados'
					},
					toolbar: {
						searchTooltip: 'Buscar',
						searchPlaceholder: 'Buscar...',
						nRowsSelected: '{0} fila(s) seleccionada(s)'
					},
					pagination: {
						labelRowsSelect: 'filas',
						labelDisplayedRows: '{count} de {from}-{to}',
						firstTooltip: 'Primera página',
						previousTooltip: 'Página anterior',
						nextTooltip: 'Próxima página',
						lastTooltip: 'Última página'
					}
				}}
			/>
		);
	}
}

export default TablaCurso;